import { render } from "./App.vue?vue&type=template&id=4bcb06a4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4bcb06a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4bcb06a4"

export default script